var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { FormattedMessage, PageTitle, Table, useToast, ToastLevel, useIntl, Button, Icon } from '@metsooutotec/modes-react-components';
import customerStore from 'stores/customer-stores/customer-store';
import AddressView from 'components/utils/address-view';
import ListView from 'components/utils/list-view/list-view';
import { ModalTypes } from '../customers-utils/customer-modal-helper';
import EntityDeleteModal from '../customers-utils/entity-delete-modal';
import { NotFound } from '../../utils/not-found';
import AssetModal from '../asset/asset-modal';
import SiteModal from './site-modal';
import { GenerateBreadcrumbs } from '../customers-utils/customers-bread-crumbs';
import { itemViewCellStyles, itemViewDetailsContainerStyles, itemViewDetailsTableStyles, itemViewListContainerStyles, itemViewListExtraTopPaddingStyles, itemViewSeparatorStyles, itemViewSubtitleStyles } from '../../common-style/common-style';
var SiteView = observer(function () {
    var _a, _b;
    var formatMessage = useIntl().formatMessage;
    var navigate = useNavigate();
    var _c = useParams(), customerId = _c.customerId, siteId = _c.siteId;
    var setMessage = useToast().setMessage;
    var location = useLocation();
    var _d = __read(useState(false), 2), isSiteModalOpen = _d[0], setSiteModalOpen = _d[1];
    var _e = __read(useState(false), 2), isAssetModalOpen = _e[0], setAssetModalOpen = _e[1];
    var _f = __read(useState(), 2), assetToEdit = _f[0], setAssetToEdit = _f[1];
    //if siteToEdit is undefinded the modal will open with empty fields to create a new site.
    var _g = __read(useState(), 2), siteToEdit = _g[0], setSiteToEdit = _g[1];
    var _h = __read(useState(false), 2), isDeleteModalOpen = _h[0], setIsDeleteModalOpen = _h[1];
    var params = location.state;
    var _j = params || {}, Created = _j.created, Edited = _j.edited;
    var customerMap = customerStore.customerMap, siteMap = customerStore.siteMap;
    var customer = customerMap[customerId || ""];
    var site = siteMap[siteId || ""];
    var showNotifier = function (text) {
        setMessage(text, ToastLevel.SUCCESS, 6000);
    };
    useEffect(function () {
        if (Created) {
            showNotifier("New site created successfully");
        }
        if (Edited) {
            showNotifier("All changes made successfully");
        }
        window.history.replaceState({}, document.title);
    }, [Created, Edited, params]);
    var siteModal = {
        open: function () {
            setSiteModalOpen(true);
            setSiteToEdit(site);
        },
        close: function (passed, siteId, navigationCustomerOptions) {
            setSiteModalOpen(false);
            setSiteToEdit(undefined);
            if (passed) {
                navigate("/customers/".concat(customerId, "/sites/").concat(siteId), {
                    state: navigationCustomerOptions
                });
            }
        }
    };
    var deleteSiteModal = {
        open: function () {
            setIsDeleteModalOpen(true);
        },
        close: function (params) {
            setIsDeleteModalOpen(false);
            if (params.deleted) {
                navigate("/customers/".concat(customerId), { state: params });
            }
        }
    };
    var createAssetModal = {
        open: function () {
            setAssetModalOpen(true);
        },
        close: function (passed, assetId, navigationCustomerOptions) {
            setAssetModalOpen(false);
            setAssetToEdit(undefined);
            if (passed) {
                navigate("/customers/".concat(customerId, "/sites/").concat(siteId, "/assets/").concat(assetId), {
                    state: navigationCustomerOptions
                });
            }
        }
    };
    var handleEditAssetIconClick = function (event, asset) {
        console.log(asset);
        event.stopPropagation();
        setAssetToEdit(asset);
        console.log(assetToEdit);
        setSiteModalOpen(false);
        setAssetModalOpen(true);
    };
    var breadcrumbsPath = GenerateBreadcrumbs(customer, site, undefined, undefined);
    var template = [
        {
            headingKey: "headings.asset",
            cellFunc: function (a) { return a.name; },
        },
        {
            headingKey: "headings.assetDescription",
            cellFunc: function (a) { return a.name; },
        },
        {
            headingKey: "headings.icon",
            cellFunc: function (a) { return _jsx(Icon, { name: "icon-edit-16", onClick: function (event) { return handleEditAssetIconClick(event, a); } }); },
        }
    ];
    var navStub = "/customers/".concat(customer === null || customer === void 0 ? void 0 : customer.id, "/sites/").concat(site === null || site === void 0 ? void 0 : site.id, "/assets");
    var rightPageButtons = (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ icon: "icon-edit-16", labelPosition: "right", onClick: siteModal.open, primary: true }, { children: formatMessage("site.edit") })), _jsx(Button, __assign({ icon: "icon-trash-16", labelPosition: "left", onClick: deleteSiteModal.open, secondary: true }, { children: formatMessage("site.delete") }))] }));
    var rightAssetButtons = (_jsx(_Fragment, { children: _jsx(Button, __assign({ icon: "icon-plus-16", labelPosition: "right", onClick: createAssetModal.open, primary: true }, { children: formatMessage("asset.addNew") })) }));
    return !site ? _jsx(NotFound, { id: siteId }) : (_jsxs(_Fragment, { children: [_jsx(PageTitle, { breadcrumbsPath: breadcrumbsPath, onPathChange: navigate, title: site.name, extraItems: rightPageButtons }), _jsxs("div", __assign({ style: itemViewDetailsContainerStyles }, { children: [_jsx("h3", __assign({ style: itemViewSubtitleStyles }, { children: _jsx(FormattedMessage, { id: "site.details" }) })), _jsx(Table, __assign({ style: itemViewDetailsTableStyles, tight: true }, { children: _jsxs(Table.Body, { children: [_jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: "headings.address" }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: _jsx(AddressView, { address: site.address }) }))] }), _jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: "site.utcOffsetHours" }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: site.utcOffsetHours }))] }), _jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: "site.longitude" }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: (_a = site.address) === null || _a === void 0 ? void 0 : _a.longitude }))] }), _jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: "site.latitude" }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: (_b = site.address) === null || _b === void 0 ? void 0 : _b.latitude }))] }), _jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: "headings.contact" }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: site.contact }))] }), _jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: "headings.metsoContact" }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: site.metsoContact }))] })] }) }))] })), _jsx("div", { style: itemViewSeparatorStyles }), _jsxs("div", __assign({ style: itemViewListContainerStyles }, { children: [_jsxs("div", __assign({ style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start" } }, { children: [_jsx("h3", __assign({ style: itemViewSubtitleStyles }, { children: _jsx(FormattedMessage, { id: "assetList.title" }) })), rightAssetButtons] })), _jsx("div", __assign({ style: site.assets && site.assets.length
                            ? itemViewListExtraTopPaddingStyles
                            : {} }, { children: _jsx(ListView, { data: site.assets || [], noneYetKey: "assetList.noAssetsYet", onClickRow: function (a) { return navigate("".concat(navStub, "/").concat(a.id)); }, template: template }) }))] })), _jsx(SiteModal, { isOpen: isSiteModalOpen, onClose: siteModal.close, site: siteToEdit, customerId: customer === null || customer === void 0 ? void 0 : customer.id }), _jsx(EntityDeleteModal, { isOpen: isDeleteModalOpen, onClose: deleteSiteModal.close, entity: site, modalType: ModalTypes.SiteModal, customerId: customer === null || customer === void 0 ? void 0 : customer.id }), _jsx(AssetModal, { isOpen: isAssetModalOpen, asset: assetToEdit, onClose: createAssetModal.close, siteId: siteId, customerId: customerId })] }));
});
export default SiteView;
